import { makeStyles } from 'tss-react/mui';

export const useStyles = makeStyles<{ cardColor: string }>()((theme, { cardColor }) => ({
  root: {
    display: 'flex',
    boxSizing: 'border-box',
    alignItems: 'center',
    textAlign: 'center',
    minHeight: theme.spacing(5),
    fontWeight: 'bold',
    flexFlow: 'inherit',
    flex: '0 0 auto',
    justifyContent: 'flex-start',
    cursor: 'pointer',
    borderRadius: theme.spacing(1.25),
    backgroundColor: cardColor,
    padding: theme.spacing(1.25),

    '&.active': {
      backgroundColor: theme.palette.primary.main,
    },

    '&:hover': {
      backgroundColor: theme.palette.primary.main,
    },
  },

  imageContainer: {
    width: theme.spacing(15),
    height: theme.spacing(7.5),
    marginRight: theme.spacing(1.875),
    borderRadius: theme.spacing(1.25),
    overflow: 'hidden',

    '& img': {
      objectFit: 'cover',
      width: '100%',
      height: '100%',
    },
  },

  title: {
    textAlign: 'left',
    textTransform: 'uppercase',
    display: 'flex',
    flex: 1,
  },
}));
